export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11149.7cc6e446.jpg";